/* Flat row, not a card: the dock's RECENT list is glanceable history, so each
 * clip is a hairline-divided row (no border/radius/fill) instead of a nested
 * box that would double up with the dock's own surface. The last row drops both
 * its divider and bottom padding so the list doesn't end on a stray rule + gap. */
.card {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  padding: var(--spacing-8) 0;
  border-bottom: 1px solid var(--stroke-neutral);
}

.card:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--spacing-8);
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-4);
}

.chip {
  font: var(--text-micro-medium);
  padding: var(--spacing-2) var(--spacing-8);
  border-radius: var(--radius-round);
}

.chip[data-tone="sensitive"] {
  color: var(--text-negative);
  background: var(--bg-tertiary);
}

.chip[data-tone="cloud"] {
  color: var(--text-tertiary);
  background: var(--bg-tertiary);
}

.body {
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-8);
}

.content {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
  font: var(--text-micro-regular);
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  color: var(--text-primary);
  /* One-line preview: history is for recall + re-copy, not full reading. Copy
   * gets the whole clip (hover shows it via the title tooltip); here we keep
   * every row a single ellipsised line so N clips stay scannable, not a wall. */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.content[data-masked] {
  letter-spacing: 0.15em;
  color: var(--text-tertiary);
  user-select: none;
}

.actions {
  display: flex;
  flex-shrink: 0;
  gap: var(--spacing-4);
}

/* Standard sr-only pattern — visually hidden but read by AT. Used for the
 * masked-content hint and the "Copied" live-region announce. */
.srOnly {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
